var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipoComprobante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.293 468.293",
    style: {
      enableBackground: "new 0 0 468.293 468.293"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E6E9"
    },
    d: "M402.732,12.488v443.317c0,6.897-5.591,12.488-12.488,12.488H78.049 c-6.897,0-12.488-5.591-12.488-12.488V86.541h86.54V0h238.143C397.141,0,402.732,5.591,402.732,12.488z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5D6DB"
    },
    points: "152.101,0 152.101,86.541 65.561,86.541 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M226.776,185.055h14.735v-37.638c0-4.069-3.299-7.367-7.367-7.367h0 c-4.069,0-7.367,3.299-7.367,7.367V185.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M226.776,369.779v37.638c0,4.069,3.299,7.367,7.367,7.367h0c4.069,0,7.367-3.299,7.367-7.367 v-37.638H226.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M364.145,270.049h-37.638v14.735h37.638c4.069,0,7.367-3.299,7.367-7.367l0,0 C371.512,273.348,368.214,270.049,364.145,270.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M104.148,284.784h37.638v-14.735h-37.638c-4.069,0-7.367,3.299-7.367,7.367l0,0 C96.78,281.486,100.079,284.784,104.148,284.784z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M234.146,180.143c-53.639,0.001-97.276,43.64-97.276,97.274h97.276V180.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD462"
    },
    d: "M136.87,277.417c0,53.634,43.638,97.273,97.276,97.274v-97.274H136.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M234.146,374.691h0.002c53.635,0,97.274-43.639,97.274-97.274h-97.276V374.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27A2DB"
    },
    d: "M234.149,180.143h-0.002v97.274h97.276C331.423,223.782,287.784,180.143,234.149,180.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5D6DB"
    },
    d: "M234.148,311.797c-18.959,0-34.384-15.424-34.384-34.38c0-18.955,15.424-34.38,34.384-34.38 c18.955,0,34.38,15.424,34.38,34.38C268.528,296.372,253.104,311.797,234.148,311.797z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBF0F3"
    },
    cx: 234.146,
    cy: 277.417,
    r: 18.732
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.236,
    y: 70.931,
    style: {
      fill: "#D5D6DB"
    },
    width: 180.361,
    height: 15.61
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipoComprobante);
export default __webpack_public_path__ + "static/media/tipo_comprobante.d7ec81ba34c9057a236eb2cca88ce1a0.svg";
export { ForwardRef as ReactComponent };